module.exports = __webpack_public_path__ + "static/media/wand.9d02d450.svg";